import { TypesTable } from './components/TypesTable'
import { TypesTableProvider } from './TypesTableContext'

const Types: React.FC = () => (
  <TypesTableProvider>
    <TypesTable />
  </TypesTableProvider>
)

export default Types
